import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
} from '../../types/user/userTypes';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return { ...state, loading: true };

    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };

    case FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    
    case CREATE_USER:
  return {
    ...state,
    users: [...state.users, action.payload],
  };

    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((d) => d.id !== action.payload),
      };

    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default userReducer;
